// ── Supabase Client ───────────────────────────────────────────────────────────
const SUPABASE_URL      = 'https://aacrsnljubmmqqxfknzp.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFhY3JzbmxqdWJtbXFxeGZrbnpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MjA1MDQsImV4cCI6MjA5NDA5NjUwNH0.tIotETY8vPRju5gS4iYcqwpBoBz3XH1NhyCjN_tvXTY';

const sbClient = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// ── Company invite code ────────────────────────────────────────────────────────
// Verified server-side via the verify_invite_code(text) RPC (value stored in the
// private app_config table). To rotate it:
//   UPDATE app_config SET value = 'new-code', updated_at = now() WHERE key = 'invite_code';

